import { Link, Navigate } from "react-router-dom";
import React from "react";
import { Alert, AlertIcon, useDisclosure } from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react'

import {
  Container,
  Box,
  IconButton,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
} from "@chakra-ui/react";
import { Button, Modal, ModalOverlay } from "@chakra-ui/react";
import { useState } from "react";

function Register() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast()
  

  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [phone,setPhone] = useState("");
  const [password,setPassword] = useState("");

  const handleSubmit = () => {
    let item = {name,email,phone,password}
    console.log(item)

    
    if(name == "" || email =="" || phone == "" || password == ""){
      toast({
        title: 'Invalid Entry',
        description: "Some input fields are invalid. Please fill the valid data",
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
      
    }
    else{
    localStorage.setItem("data", JSON.stringify(item));
    toast({
      title: 'Account created.',
      description: "Your Account is Successfully created ! Now Login.",
      status: 'success',
      duration: 9000,
      isClosable: true,
    })

    onClose();

  }
  }

  return (
    <>
      <Button colorScheme="transparent" onClick={onOpen}>
        Register
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create Your Account</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input ref={initialRef} type="text" placeholder="Enter Name" value={name} onChange={(e) => setName(e.target.value)}/>
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Email</FormLabel>
              <Input type="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Password</FormLabel>
              <Input type="mobile" placeholder="Enter Mobile Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Password</FormLabel>
              <Input type="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)}/>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
              Sign Up
            </Button>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
export default Register;
